exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".file-input-container{width:210px;display:inline-block;position:relative}.file-input-container .file-input{position:absolute;opacity:0;width:100%;height:35px;top:0}.file-input-container .file-input-btn{width:100%}.file-input-container .file-input-filelist{margin-top:20px}.file-input-container .file-input-filelist .file-input-file-icon{margin-right:10px;font-size:1.2em;color:#2196f3}.file-input-container .file-input-filelist .file-input-upload{margin-top:10px}.file-input-container .file-input-filelist .file-input-upload-icon-wraper{text-align:center}.file-input-container .file-input-filelist .file-input-upload-icon{font-size:1.2em;color:#2196f3;margin-right:5px}.file-input-container .file-input-filelist .file-input-upload-progress-wraper{padding-top:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/postcss-loader!../~/sass-loader/dist/cjs.js!./components/lib/FileInput/fileInput.scss
// module id = 1172
// module chunks = 0 1